import {
  FONT_SIZE_DEFAULT_PX,
  FONT_SIZE_LEGACY_PRESETS,
  FONT_SIZE_MAX_PX,
  FONT_SIZE_MIN_PX,
  FONT_SIZE_STORAGE_KEY,
} from '@/shared/constants/font-size';

export function clampFontSizePx(px: number): number {
  return Math.min(FONT_SIZE_MAX_PX, Math.max(FONT_SIZE_MIN_PX, px));
}

export function loadFontSizePx(): number {
  try {
    const raw = localStorage.getItem(FONT_SIZE_STORAGE_KEY);
    if (!raw) return FONT_SIZE_DEFAULT_PX;

    if (raw in FONT_SIZE_LEGACY_PRESETS) {
      return FONT_SIZE_LEGACY_PRESETS[raw as keyof typeof FONT_SIZE_LEGACY_PRESETS];
    }

    const parsed = Number.parseInt(raw, 10);
    if (!Number.isNaN(parsed)) return clampFontSizePx(parsed);
  } catch {
    /* ignore */
  }
  return FONT_SIZE_DEFAULT_PX;
}

export function applyFontSizePx(px: number): number {
  const clamped = clampFontSizePx(px);
  document.documentElement.style.fontSize = `${clamped}px`;
  return clamped;
}

export function saveFontSizePx(px: number): void {
  try {
    localStorage.setItem(FONT_SIZE_STORAGE_KEY, String(clampFontSizePx(px)));
  } catch {
    /* ignore */
  }
}

export function initFontSizeFromStorage(): void {
  applyFontSizePx(loadFontSizePx());
}
